import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { ServiceRouter } from '@pershing/pershing-core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { TradingOrderStatusServiceDefinition } from '../../models/common/order-status-service-definition';

@Injectable()
export class OrderStatusService {
    private orderStatusBaseUrl: string;
    private acctNumParam: string = 'urn:id:headers.x-AccountNumber';

    private onOrdersSubject = new BehaviorSubject<any | null>(null);
    private platform: string;
    onOrdersSubject$ = this.onOrdersSubject.asObservable();
    private subscription: Subscription = null;
    

    constructor(private http: HttpClient, private serviceRouter: ServiceRouter, @Optional() @Inject('AppSettings') appSettings: any) {
        if (appSettings?.platform) {
            this.platform = appSettings.platform;
        } else {
            this.platform = 'professional';
        }
        this.orderStatusBaseUrl = this.serviceRouter.getServiceRouteURL(TradingOrderStatusServiceDefinition.getInstance(this.platform), 
        { ignoreOptions: { serviceVersion: true } });
    }

    private getHttpHeadersWithAcctNumOrGroupName(acctOrGroupNum: string, isGroup = false ) {
        let acctOrGroupKey = isGroup ? 'x-GroupName' : 'x-AccountNumber';
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            [acctOrGroupKey]: acctOrGroupNum
        });

        return headers;
    }

    private convertJsonToParam(searchObj?: {}): HttpParams{
        if (searchObj) {
            let params = new HttpParams();
            for (let key in searchObj) {
                if (searchObj.hasOwnProperty(key)) {
                    let val = searchObj[key];
                    params = params.append(key, val);
                }
            }
            return params;
        }
    }

    public successHandler = success => this.onOrdersSubject.next(success);
    public errorHandler = err => this.onOrdersSubject.next(err);

    // searchObj - { orderStatusCode: $value, securityType: $value }
    public getOrdersStatus(platform: string, acctNum: string, searchObj?: {}): void {
        let url = this.orderStatusBaseUrl + '/' + this.acctNumParam;
        let _params = searchObj ? this.convertJsonToParam(searchObj) : undefined;
        this.subscription?.unsubscribe();
        this.subscription = this.http.get(url, { headers: this.getHttpHeadersWithAcctNumOrGroupName(acctNum), params: _params }).subscribe(this.successHandler, this.errorHandler);
    }

    // endpoint for groups of accounts (/trading/orders/group/{groupName})
    public getOrdersStatusGroup(groupName: string, searchObj?: {}): void {
        let url = this.orderStatusBaseUrl + '/group/' + groupName;
        let _params = searchObj ? this.convertJsonToParam(searchObj) : undefined;
        this.subscription?.unsubscribe();
        this.subscription = this.http.get(url, { headers: this.getHttpHeadersWithAcctNumOrGroupName(groupName, true), params: _params }).subscribe(this.successHandler, this.errorHandler);
    }

}